// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_924b119625--wrapper--bJb6B","dashed_line":"_924b119625--dashed_line--PXdcA"};